import { useState } from 'react';
import classNames from 'classnames';
import { Button } from '@forma/forma-ui-kit';
import PageBlock from '@/components/PageBlock';
import RequestDemoModal3 from '@/components/blocks/RequestDemoModal3';

import styles from './partnership-info.module.css';

const PartnershipInfo = ({ title, items, callModal }) => {
  const [isRequest3Open, setRequest3Open] = useState(false);

  return (
    <PageBlock
      className={styles.root}
      title={title}
      variant="filled"
      contentClassName={styles.grid}
    >
      {items.map(({ name, description, icon }) => (
        <div className={styles.item} key={name}>
          <div className={styles.iconWrap}>
            <img className={styles.icon} src={icon} width={32} height={32} alt={name} />
          </div>
          <div className={styles.content}>
            <div className={styles.name}>{name}</div>
            <div className={styles.description}>{description}</div>
          </div>
        </div>
      ))}
      <div className={classNames(styles.item, styles.large)}>
        <div className={styles.name}>Станьте партнёром DataDoc сегодня</div>
        <Button
          viewStyle="secondary"
          className={styles.button}
          onClick={() => setRequest3Open(true)}
        >
          {callModal.button}
        </Button>
      </div>

      <RequestDemoModal3
        open={isRequest3Open}
        onClose={setRequest3Open}
        title={callModal?.title}
        description={callModal?.description}
        buttonText={callModal?.button}
        additional={callModal?.additional}
      />
    </PageBlock>
  );
};

export default PartnershipInfo;
